/**
 * Configuration centrale de la Radio 100% Johnny.
 * Ne pas dupliquer l'URL du flux dans les pages/composants.
 */
export const RADIO_CONFIG = Object.freeze({
  STREAM_URL: 'https://play.radioking.io/radio-johnny-hallyday',
  TRACK_API_URL: 'https://api.radioking.io/widget/radio/radio-johnny-hallyday/track/current',
  WEBSITE_URL: 'https://100pour100johnny.com',
})

export default RADIO_CONFIG
